import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalIaModulePageRoutingModule } from './modal-ia-module-routing.module';

import { ModalIaModulePage } from './modal-ia-module.page';

import { ModalAdditionalQuestionsPageModule } from '../modal-additional-questions/modal-additional-questions.module';

import { ModalIaResultsResumePageModule } from '../modal-ia-results-resume/modal-ia-results-resume.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalIaModulePageRoutingModule,
    ModalAdditionalQuestionsPageModule,
    ModalIaResultsResumePageModule
    
  ],
  declarations: [ModalIaModulePage]
})
export class ModalIaModulePageModule {}
